import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { NoteFormValues } from 'modules/notes/notePopup/noteEdit/utils';
import type { StatusesItem } from 'store/clients/clientsSlice';

export type NoteModalConfig = {
  status: StatusesItem['id'];
  clientId: string;
  clientName: string;
  prependedClientId: string;
  note: Partial<NoteFormValues>;
};

type NoteModalState = {
  config: NoteModalConfig | null;
  hidden: boolean;
};

const initialState: NoteModalState = {
  config: null,
  hidden: false
};

const noteModalSlice = createSlice({
  name: 'noteModal',
  initialState,
  reducers: {
    openNoteModal: (state, action: PayloadAction<NoteModalConfig>) => {
      state.config = action.payload;
      state.hidden = false;
    },
    closeNoteModal: () => initialState,
    hideNoteModal: (state) => {
      if (state.config) {
        state.hidden = true;
      }
    },
    showNoteModal: (state) => {
      if (state.config) {
        state.hidden = false;
      }
    }
  }
});

export const { openNoteModal, closeNoteModal, hideNoteModal, showNoteModal } =
  noteModalSlice.actions;

export default noteModalSlice.reducer;
